import React from 'react';
import * as styles from './container.module.sass';

export const DoubleText = (props: any) => {
  return (
    <div className={styles.count_container}>
      <h1 className={styles.count_title}>
        {props.title}
      </h1>
      <p className={styles.count_description}>{props.subtitle}</p>
    </div>
  );
};
